import { makeAction } from './index';

export const clearAllErrors = makeAction('CLEAR_ALL_ERRORS');
